{
  "appointment": {
    "CONFIRMATION_NUMBER": "Confirmación #",
    "APPOINTMENT_ID": "ID de cita",
    "APPOINTMENT_DATE": "Fecha de cita",
    "APPOINTMENT_TIME": "Hora de cita",
    "APPOINTMENT_TIMEZONE": "Zona horaria",
    "APPOINTMENT_TYPE": "Tipo de cita",
    "SCHEDULED_DURATION": "Duración programada (min)",
    "STATUS": "Estado",
    "ARRIVAL_DATE": "Fecha de llegada",
    "ARRIVAL_TIME": "Hora de llegada",
    "DEPARTURE_DATE": "Fecha de salida",
    "DEPARTURE_TIME": "Hora de salida",
    "DWELL_TIME": "Tiempo de permanencia (min)",
    "ON_TIME": "Puntualidad (min)",
    "IN_PROGRESS_DATE": "Fecha de inicio (en progreso)",
    "IN_PROGRESS_TIME": "Hora de inicio (en progreso)",
    "WAIT_TIME": "Tiempo de espera (min)",
    "PROCESSING_TIME": "Tiempo de procesamiento (min)",
    "WAREHOUSE": "Almacén",
    "DOCK": "Muelle",
    "LOAD_TYPE": "Tipo de carga",
    "LOAD_TYPE_DIRECTION": "Dirección",
    "RESCHEDULE_COUNT": "Cantidad de reprogramaciones",
    "CREATED_BY": "Creado por",
    "CREATOR_TYPE": "Tipo de creador",
    "CREATION_DATE": "Fecha de creación",
    "LAST_UPDATED_BY": "Última actualización por",
    "LAST_UPDATE_DATE": "Fecha de última actualización",
    "LAST_UPDATE_TIME": "Hora de última actualización",
    "CARRIER_COMPANY": "Empresa transportista",
    "CONTACT_NAME": "Nombre del contacto",
    "CONTACT_EMAIL": "Correo del contacto",
    "CONTACT_PHONE": "Teléfono del contacto",
    "NOTES": "Notas",
    "TAGS": "Etiquetas",
    "CUSTOM_FIELDS": "Campos personalizados",
    "EXTERNAL_VALIDATION_STATUS": "Estado de validación externa",
    "EXTERNAL_VALIDATION_ERROR_MESSAGE": "Mensaje de error de validación externa",
    "CheckOut": "Salida",
    "CheckInAdditionalAssetDetails": "Detalles adicionales del activo en la entrada",
    "InboundClaim": "Reclamación de entrada",
    "OutboundClaim": "Reclamación de salida",
    "BookLoadType": "Tipo de carga de la reserva",
    "AssetContainerDetails": "Detalles del contenedor del activo",
    "AppointmentCompleted": "Cita completada"
  },
  "assetVisit": {
    "id": "ID de visita",
    "appointmentId": "ID de cita",
    "checkInDate": "Fecha de entrada",
    "checkOutDate": "Fecha de salida",
    "carrier": "Transportista",
    "warehouseName": "Almacén",
    "currentStatus": "Estado",
    "licensePlate": "Placa",
    "visitType": "Tipo de visita",
    "dotNumber": "Número DOT",
    "phone": "Teléfono",
    "isPlanned": "Planificada",
    "driverNotes": "Notas del conductor",
    "checkInAcknowledged": "Entrada confirmada",
    "firstName": "Nombre (verificación de ID)",
    "lastName": "Apellido (verificación de ID)",
    "birthdate": "Fecha de nacimiento (verificación de ID)",
    "idValidationEmail": "Correo (verificación de ID)",
    "idValidationPhone": "Teléfono (verificación de ID)"
  }
}
